<template>
	<div>
		<van-cell-group>
			<van-cell title="日期" :value="currentDateShow" @click="show=true" />
		</van-cell-group>

		<van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
			<van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate" @confirm="confirm()"
			 @cancel="show=false" />
		</van-popup>

		<div class="drop-box">
			<p class="drop-lable">班次</p>
			<van-dropdown-menu class="drop-item-1">
				<van-dropdown-item v-model="abnormalStatus" :options="abnormalStatusList" @change="selectThisClassess" />
			</van-dropdown-menu>
		</div>
		<div class="bg-div"></div>
		<div class="no-data" v-if="historyList.length == 0">
			<img src="../../assets/no_data.svg" alt="">
			<p class="color-gray">当前没有数据</p>
		</div>
		<van-cell clickable v-for="(it, index) in historyList" :key="index" @click="selectThisStu(it)">
			<div class="list-box">
				<div class="list-msg">
					<p v-text="it.name"></p>
					<div>
						<span class="color-gray" v-text="it.depts[0].name"></span>
						<span class="color-gray" v-text="it.stuOrTechCode"></span>
					</div>
				</div>
				<p class="list-temp" :class="{ 'color-red': !it.isReasonable }" v-text="it.tempF"></p>
				<div class="list-time">
					<p v-text="it.createTime"></p>
					<p class="color-gray" v-text="it.updateTime"></p>
				</div>
			</div>
		</van-cell>
		<bottom-tab></bottom-tab>
	</div>
</template>

<script>
	import Vue from 'vue';
	import api from '../../http/api.js'

	import {
		Popup,
		Cell,
		Calendar,
		Toast
	} from 'vant';

	Vue.use(Toast);
	Vue.use(Calendar);
	Vue.use(Cell);
	Vue.use(Popup);

	export default {
		data() {
			return {
				show: false,
				minDate: new Date(2019, 0, 1),
				maxDate: new Date(2030, 11, 31),
				currentDateShow: this.formatDate(new Date(), "yyyy/MM/dd"),
				currentDate: new Date(),
				abnormalStatus: 0,
				abnormalStatusList: [],
				schoolId: window.localStorage.getItem('scId'),
				historyList: [],
				minTemp: window.localStorage.getItem('minTemp'),
				maxTemp: window.localStorage.getItem('maxTemp'),
			}
		},
		methods: {
			pageInit() {
				let aa = -1; //临时变量, 无任何意义.
				let key = "school_" + this.getLocalStorage("scId") + "_TempInfo";
				api.loadAreaTempInfo(key).then(res => {
					//解析班次
					let temp = JSON.parse(res.data.data.configValue).scheduleList;
					//填充班次数据
					for (let i = 0; i < temp.length; i++) {
						temp[i]["text"] =
							temp[i].name + ": " + temp[i].startTime + ' - ' + temp[i].endTime;
						temp[i]["value"] = temp[i].id;
					}

					//处理班次匹配回填
					let flag = 0;
					while (aa == -1  && flag < temp.length) {
						aa = this.checkAuditTime(
							temp[flag].startTime,
							temp[flag].endTime,
							temp[flag].id
						);
						flag++;
					}
					// this.abnormalStatus = aa;
					if( aa != -1 && temp && temp.length > 0){
						this.abnormalStatus = aa;
						console.log(this.abnormalStatus)
					}else if(aa == -1 && temp && temp.length > 0){
						this.abnormalStatus = temp[0].id
					}else{
						this.abnormalStatus = aa
					}
					this.abnormalStatusList = temp;

					console.log(this.currentDate)
					this.currentDateShow = this.formatDate(this.currentDate, "yyyy/MM/dd");
					this.searchData()
				})
			},

			selectThisClassess(value) {
				this.searchData()
			},
			confirm() {
				this.show = false;
				console.log(this.currentDate);
				this.currentDateShow = this.formatDate(this.currentDate, "yyyy/MM/dd");
				this.searchData()
			},
			checkAuditTime(beginTime, endTime, value) {
				var nowDate = new Date();
				var beginDate = new Date(nowDate);
				var endDate = new Date(nowDate);
				console.log(beginTime)
				var beginIndex = beginTime.lastIndexOf(":");
				var beginHour = beginTime.substring(0, beginIndex);
				var beginMinue = beginTime.substring(beginIndex + 1, beginTime.length);
				beginDate.setHours(beginHour, beginMinue, 0, 0);

				var endIndex = endTime.lastIndexOf(":");
				var endHour = endTime.substring(0, endIndex);
				var endMinue = endTime.substring(endIndex + 1, endTime.length);
				endDate.setHours(endHour, endMinue, 0, 0);
				if (
					nowDate.getTime() - beginDate.getTime() >= 0 &&
					nowDate.getTime() <= endDate.getTime()
				) {
					return value;
				} else {
					return -1;
				}
			},
			getLocalStorage(key) {
				return window.localStorage.getItem(key);
			},
			selectThisStu(it) {
				this.$router.push({
					path: '/peopleTemp',
					query: {
						id: it.userId
					}
				})
			},
			searchData() {
				// 查询接口
				// let page = this
				let dataArray = []
				this.historyList = []
				let startTime_c = ''
				let endTime_c = ''
				for (let i = 0; i < this.abnormalStatusList.length; i++) {
					if (this.abnormalStatusList[i].value == this.abnormalStatus) {
						startTime_c = this.currentDateShow + " " + this.abnormalStatusList[i].startTime + ":00"
						endTime_c = this.currentDateShow + " " + this.abnormalStatusList[i].endTime + ":00"
					}
				}
					console.log(window.localStorage.getItem('uid'))
					console.log(window.localStorage.getItem('sid'))
				let data = {
					
					schoolId: this.schoolId,
					end: endTime_c,
					start: startTime_c,
					pageNum: 1,
					pageSize: 100,
					userId: window.localStorage.getItem('sid')
				}
				for (let attr in data) {
					dataArray.push(`${attr}=${data[attr]}`)
				}
				api.getTempHistory2(dataArray).then(res => {
					if (res.data.code == 200) {
						for (let i = 0; i < res.data.data.content.length; i++) {
							this.historyList.push(res.data.data.content[i])
							if(this.historyList[i].tempF > this.minTemp && this.historyList[i].tempF < this.maxTemp){
								this.historyList[i].isReasonable = true
							}else{
								this.historyList[i].isReasonable = false
							}
							if(this.historyList[i].tempF.toString().length == 2){
								this.historyList[i].tempF = this.historyList[i].tempF.toString() + '.0'
							}
						}
						console.log(this.historyList)
						this.$forceUpdate()
					} else {
						Toast('获取失败：' + res.data.msg)
					}
				})
			},
			formatDate(date, fmt) {
				date = date == undefined ? new Date() : date;
				date = typeof date == "number" ? new Date(date) : date;
				fmt = fmt || "yyyy-MM-dd HH:mm:ss";
				let obj = {
					y: date.getFullYear(), // 年份，注意必须用getFullYear
					M: date.getMonth() + 1, // 月份，注意是从0-11
					d: date.getDate(), // 日期
					q: Math.floor((date.getMonth() + 3) / 3), // 季度
					w: date.getDay(), // 星期，注意是0-6
					H: date.getHours(), // 24小时制
					h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
					m: date.getMinutes(), // 分钟
					s: date.getSeconds(), // 秒
					S: date.getMilliseconds() // 毫秒
				};
				let week = ["天", "一", "二", "三", "四", "五", "六"];
				for (let i in obj) {
					fmt = fmt.replace(new RegExp(i + "+", "g"), function(m) {
						let val = obj[i] + "";
						if (i == "w") return (m.length > 2 ? "星期" : "周") + week[val];
						for (let j = 0, len = val.length; j < m.length - len; j++)
							val = "0" + val;
						return m.length == 1 ? val : val.substring(val.length - m.length);
					});
				}
				return fmt;
			}
		},
		activated() {
			console.log(this.$route.meta.isBack)
			if (!this.$route.meta.isBack) {
				this.show = false
				this.currentDateShow = this.formatDate(new Date(), "yyyy/MM/dd")
				this.currentDate = new Date()
				this.abnormalStatus = 0
				this.abnormalStatusList = []
				this.historyList = []

				this.pageInit()
			}
		},
		beforeRouteEnter(to, from, next) {
			if (from.name != 'peopleTemp') {
				to.meta.isBack = false;
				// window.location.reload();
			} else {
				to.meta.isBack = true;
			}
			next();
		}

	}
</script>

<style scoped>
	.list-box p,
	span {
		margin: 0;
	}

	.list-box {
		display: flex;
		justify-content: space-between;
	}

	.list-msg {
		width: 35%;
	}

	.list-msg span {
		font-size: 0.2rem;
	}

	.list-temp {
		width: 10%;
	}

	.list-time {
		width: 55%;
		text-align: right;
	}

	.list-time p:nth-child(2) {
		font-size: 0.2rem;
	}

	.color-gray {
		color: #909399;
	}

	.color-red {
		color: red;
	}

	.van-dropdown-menu__title {
		line-height: 1rem !important;
	}

	.drop-item-1 {
		height: 1rem;
	}

	.no-data {
		padding-top: 1rem;
		text-align: center;
	}

	.bg-div {
		background: rgb(245, 246, 249);
		height: 10px;
	}
</style>
